/**
 * React Query key factories + shared query client config.
 *
 * A single source of truth for cache keys keeps invalidations sane once
 * more surfaces start writing (leads, card edits, etc.).
 */
import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "@/lib/api";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      retry: (failureCount, error) => {
        // Never retry auth errors; retry once for everything else.
        if (error instanceof ApiError && [401, 403, 404, 422].includes(error.status)) {
          return false;
        }
        return failureCount < 1;
      },
    },
    mutations: {
      retry: 0,
    },
  },
});

export const qk = {
  me: ["me"],
  actionCenter: ["action-center"],
  growthScore: ["growth-score"],
  growthScoreTrend: ["growth-score", "trend"],
  cardBadge: ["card", "notifications-badge"],
  templates: ["templates"],
};
